import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RocketSVG from "../../../assets/images/rocket.svg";
import LazoModal from "../utils/LazoModal";

export function ModuleNoAccessModal() {
  const navigate = useNavigate();
  const { t } = useTranslation("paywall");

  function handleClose() {
    navigate(-1);
  }

  return (
    <LazoModal
      open={true}
      handleClose={handleClose}
      title={t("modals.moduleNoAccess.title")}
      buttons={null}
      titleSxProps={{ fontWeight: "600" }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        padding={{ xs: "16px", sm: "24px" }}
        flexDirection="column"
        gap="1rem"
        minHeight="10.750rem"
      >
        <img src={RocketSVG.src} alt="rocket-svg" />
        <Typography>{t("modals.moduleNoAccess.description")}</Typography>
      </Box>
    </LazoModal>
  );
}
